import { pdfjs } from 'react-pdf';

/**
 * Configures PDF.js worker for react-pdf components
 * This should be called once during application initialization
 */
export const configurePdfWorker = () => {
	pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
};
